/* eslint-disable */
import React from 'react'
import {message} from 'antd'
import http from '../../Component/Interceptor/Interseptor'
import {MDBBreadcrumb, MDBBreadcrumbItem} from 'mdbreact'
import {Link} from 'react-router-dom'
import cookie from 'react-cookies'
import BASE_MANAGE from '../BaseComponent/BASEMANAGE'
import USER_MANAGE from '../BaseComponent/USERMANAGE'

class AddPersonReason extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      error: ''
    }
  }
  componentDidMount() {}

  addPersonReason() {
    var name = document.getElementById('name').value
    var type = document.getElementById('type').value
    var nameError = false
    var typeError = false
    var formError = false
    if (name == '') {
      formError = true
      nameError = true
      message.error('نام دلیل وارد شود')
    } else {
      if (!nameError) {
        this.setState({
          error: ''
        })
      }
    }

    if (type == '') {
      formError = true
      type = true
      message.error('نوع دلیل کاربر را وارد کنید')
    } else {
      if (!type) {
        this.setState({
          error: ''
        })
      }
    }

    if (!formError) {
      let data = {
        name: name,
        type: type
      }

      http
        .post(`${USER_MANAGE.USER_MANAGE_BASE_STATEREASON_ADD}`, data)
        .then((response) => {
          if (response.data.error == null) {
            message.success('دلیل کاربر جدید اضافه شد')
            setInterval(() => {
              window.location.assign('/PersonReason')
            }, 2000)
          } else {
            message.error('خطای ' + response.data.errorCode + ' : ' + response.data.description)
          }
        })
        .catch((error) => {
          alert(JSON.stringify(error))
        })
    }
  }

  submit(e) {
    e.preventDefault()
  }

  render() {
    return (
      <div className={'rtl'}>
        {/*<AdminMenu/>*/}
        <div className="wrapperIframe">
          <ul className="breadcrumb">
            <li>
              <Link to={'/search'}>به روزرسان</Link>
            </li>
            <li>
              <Link to={'/PersonReason'}>لیست دلایل کاربر</Link>
            </li>
            <li>ثبت دلیل کاربر</li>
          </ul>
          <form className="verticalForm" onSubmit={this.submit.bind(this)}>
            <div className="headerVertical">
              <p>ثبت دلیل کاربر</p>
            </div>
            <div className="formComponent">
              <label>
                نام دلیل کاربر <span className="requireFiled">*</span>
              </label>
              <input type="text" id="name" className="form-control" />

              <label>
                نوع <span className="requireFiled">*</span>
              </label>
              <select className="form-control" name="type" id="type">
                <option value="">نوع را مشخص کنید</option>
                <option value="-1">عمومی</option>
              </select>

              <button className="btn btn-info btn-block" onClick={this.addPersonReason.bind(this)}>
                ثبت دلیل کاربر
              </button>
            </div>
          </form>
        </div>
      </div>
    )
  }
}

export default AddPersonReason
